<style lang="scss">

</style>

<template>
  <div class="p-1">
    <!--  No Contacts Found -->
    <section v-if="stage === 1">
      <h2 class="text-center mb-2">No contacts found!</h2>
      <p>We could not find any offsite contacts belong to the {{ $options.filters.term('prisoner') }} number
        {{ prisonerNumber }}.
        Please re-enter the {{ $options.filters.term('prisoner') }} number or create a new offsite contact.
      </p>
      <section class="d-flex full-width justify-content-end">
        <button @click="setStage(2)" class="btn btn-primary mr-2">Create new inter-prison contact</button>
        <button @click="close()" class="btn btn-danger">Close and re-enter</button>
      </section>
    </section>

    <!--  Add New Contact  -->
    <section v-if="stage > 1">
      <h3 class="text-center mb-2">Add New Contact</h3>
      <offsite-contacts-prisoner-info v-if="stage === 2"></offsite-contacts-prisoner-info>
      <offsite-contacts-visitor-info @contact="$emit('contact')" v-if="stage === 3"></offsite-contacts-visitor-info>
    </section>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import OffsiteContactsPrisonerInfo from '@/components/bookVisit/offsiteVisit/OffsiteContactsPrisonerInfo';
import OffsiteContactsVisitorInfo from '@/components/bookVisit/offsiteVisit/OffsiteContactsVisitorInfo';

export default {
  props: {},
  components: {
    OffsiteContactsPrisonerInfo,
    OffsiteContactsVisitorInfo,
  },
  computed: {
    ...mapState({
      prisonerNumber: state => state.booking.offsiteBooking.prisonerNumber,
      offsiteContact: state => state.booking.offsiteContact,
      sites: state => state.booking.offsiteEstablishments,
      stage: state => state.booking.offsiteStage,
    }),
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    setStage(number) {
      this.$store.commit('booking/SET_OFFSITE_STAGE', number);
    },
    setVuexProp(e, prop) {
      this.$store.commit('booking/SET_OFFSITE_CONTACT_ITEM', {prop, value: e});
    },
    close() {
      this.$emit('close', true);
    }
  },
};
</script>
